var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;

module.exports = function (e) {
  var o = {};

  function t(r) {
    if (o[r]) return o[r].exports;
    var n = o[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  return t.m = e, t.c = o, t.d = function (e, o, r) {
    t.o(e, o) || Object.defineProperty(e, o, {
      enumerable: !0,
      get: r
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, o) {
    if (1 & o && (e = t(e)), 8 & o) return e;
    if (4 & o && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (t.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & o && "string" != typeof e) for (var n in e) {
      t.d(r, n, function (o) {
        return e[o];
      }.bind(null, n));
    }
    return r;
  }, t.n = function (e) {
    var o = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(o, "a", o), o;
  }, t.o = function (e, o) {
    return Object.prototype.hasOwnProperty.call(e, o);
  }, t.p = "", t(t.s = 60);
}({
  1: function _(e, o) {
    e.exports = require("react");
  },
  2: function _(e, o) {
    e.exports = require("styled-components");
  },
  60: function _(e, o, t) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var o = {};
      if (null != e) for (var t in e) {
        Object.hasOwnProperty.call(e, t) && (o[t] = e[t]);
      }
      return o.default = e, o;
    };

    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    var n = r(t(1)),
        l = r(t(2)),
        a = t(61),
        i = l.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]))),
        s = l.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  padding: 3px 8px;\n  margin: 3px 0 3px 5px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: bold;\n  text-align: right;\n\n  transition: all 0.5s ease-out;\n  pointer-events: all;\n  user-select: none;\n  cursor: pointer;\n\n  color: #ffffffa8;\n  background-color: ", ";\n  box-shadow: 0 0 5px ", ";\n  ", "\n  ", "\n\n  ", "\n"])), function (_ref) {
      var e = _ref.color;
      return e;
    }, function (_ref2) {
      var e = _ref2.color;
      return e;
    }, function (_ref3) {
      var e = _ref3.top;
      return "top: ".concat(e, "px;");
    }, function (_ref4) {
      var e = _ref4.styles;
      return e;
    }, function (_ref5) {
      var e = _ref5.open,
          o = _ref5.color;
      return e && l.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n    padding: 3px 12px 12px 8px;\n    background-color: #000;\n  "])), o);
    }),
        c = l.default.div.attrs(function () {
      return {
        className: "expandable-content"
      };
    })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n  transition: all 0.5s ease-out;\n  font-weight: normal;\n  color: white;\n\n  ", "\n"])), function (_ref6) {
      var e = _ref6.open;
      return e && l.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  "])));
    }),
        d = l.default.div.attrs(function () {
      return {
        className: "extra-info"
      };
    })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n\n  padding: 0 5px;\n  height: 100%;\n  background: #000;\n  border-radius: 4px;\n\n  opacity: 0;\n  transition: all 0.5s ease-out;\n\n  ", "\n"])), function (_ref7) {
      var e = _ref7.open;
      return e && l.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    opacity: 1;\n  "])));
    }),
        f = l.default.div.attrs(function () {
      return {
        className: "extra-block"
      };
    })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0px 3px;\n  margin: 3px 4px 3px 0px;\n  border-radius: 2px;\n  font-size: 11px;\n  font-weight: bold;\n  color: #FFF;\n  background-color: ", ";\n\n  &:last-child {\n    margin: 3px 0px;\n  }\n\n  &:only-child {\n    margin: 3px 0px;\n  }\n"])), function (_ref8) {
      var e = _ref8.color;
      return e;
    });

    o.ExpandableBadge = function (e) {
      var o = e.title,
          t = e.content,
          r = e.labels,
          l = e.color,
          a = e.styles,
          u = e.show,
          _n$useState = n.useState(u),
          _n$useState2 = _slicedToArray(_n$useState, 2),
          p = _n$useState2[0],
          x = _n$useState2[1];

      return n.default.createElement(i, {
        className: "lego-logger"
      }, n.default.createElement(d, {
        open: p
      }, r && r.map(function (e, o) {
        return n.default.createElement(f, {
          key: o,
          color: e.color
        }, e.name);
      })), n.default.createElement(s, {
        styles: a,
        onClick: function onClick() {
          return x(!p);
        },
        open: p,
        color: l
      }, o, n.default.createElement(c, {
        open: p
      }, t && t())));
    };

    var u = l.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 10px;\n  right: 10px;\n\n  display: flex;\n  flex-direction: column;\n\n  pointer-events: none;\n  z-index: 9999999999999;\n  opacity: 0.9;\n\n  ", "\n"])), function (_ref9) {
      var e = _ref9.show;
      return !e && l.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["display: none;"])));
    });
    o.BadgeButton = l.default.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background-color: #ffffff20;\n  padding: 1px 2px;\n  border-radius: 3px;\n  border: none;\n  outline: none;\n\n  color: white;\n  font-size: 9px;\n  pointer-events: all;\n  cursor: pointer;\n"]))), o.ListContainer = l.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: auto;\n  max-height: 200px;\n  overflow: hidden;\n  mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0.5)));\n  mask-size: 100% 120%;\n  overflow-y: scroll;\n  pointer-events: all;\n\n  ", "\n"])), function (_ref10) {
      var e = _ref10.show;
      return !e && l.css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["display: none;"])));
    });

    var p = function p(e, t) {
      return e ? e.hide ? "" : e.childs ? n.default.createElement(o.ListBadge, {
        key: t,
        title: e.title,
        list: e.childs,
        color: e.color,
        open: e.open
      }) : n.default.createElement(a.Badge, {
        key: t,
        show: !0,
        color: e.color
      }, e.action ? n.default.createElement(o.BadgeButton, {
        onClick: e.action
      }, e.title) : e.title) : "";
    };

    o.ListBadge = function (_ref11) {
      var e = _ref11.title,
          t = _ref11.list,
          r = _ref11.color,
          l = _ref11.badgeStyles,
          i = _ref11.open;

      var _n$useState3 = n.useState(i),
          _n$useState4 = _slicedToArray(_n$useState3, 2),
          s = _n$useState4[0],
          c = _n$useState4[1];

      return n.default.createElement(n.default.Fragment, null, n.default.createElement(a.Badge, {
        styles: l,
        color: r
      }, n.default.createElement(n.default.Fragment, null, "" + e, n.default.createElement(o.BadgeButton, {
        onClick: function onClick() {
          return c(!s);
        }
      }, s ? "▲" : "▼"))), n.default.createElement(o.ListContainer, {
        show: s
      }, t.map(function (e, t) {
        if (e) {
          if (e.childs) return n.default.createElement(o.ListBadge, {
            key: t,
            title: e.title,
            list: e.childs,
            color: e.color || r
          });
          if (e.content) return n.default.createElement(o.ExpandableBadge, {
            key: t,
            title: e.title,
            content: e.content,
            labels: e.labels,
            styles: l,
            color: e.color || r,
            show: e.open
          });
        }

        return p(e, t);
      })));
    };

    o.default = function (_ref12) {
      var e = _ref12.data,
          o = _ref12.show;
      return n.default.createElement(u, {
        show: o
      }, e.map(function (e, o) {
        return p(e, o);
      }));
    };
  },
  61: function _(e, o, t) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var o = {};
      if (null != e) for (var t in e) {
        Object.hasOwnProperty.call(e, t) && (o[t] = e[t]);
      }
      return o.default = e, o;
    };

    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    var n = r(t(2));
    o.NeutralColors = n.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: #a3e1ff;\n  background-color: #0078b1;\n  box-shadow: 0 0 5px #00557d;\n"]))), o.InfoColors = n.css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: #76ffd5;\n  background-color: #00776d;\n  box-shadow: 0 0 5px #00506f;\n"]))), o.SuccessColors = n.css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: #76ff81;\n  background-color: #007725;\n  box-shadow: 0 0 5px #006f23;\n"]))), o.DangerColors = n.css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: #ff8576;\n  background-color: #b10000;\n  box-shadow: 0 0 5px #b10000;\n"]))), o.NoteColors = n.css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  color: #fff1a3;\n  background-color: #8c6f00;\n  box-shadow: 0 0 5px #7d5700;\n"]))), o.WarningColors = n.css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  color: #ffca76;\n  background-color: #b13b00;\n  box-shadow: 0 0 5px #b13d00;\n"]))), o.OtherColors = n.css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  color: #dfc2ff;\n  background-color: #673f92;\n  box-shadow: 0 0 5px #2a0056;\n"]))), o.Badge = n.default.div.attrs(function () {
      return {
        className: "badge"
      };
    })(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 2px 5px;\n  margin: 3px 0 3px auto;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: bold;\n\n  transition: all 0.3s ease;\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.6;\n\n  color: #ffffffaf;\n  background-color: ", ";\n  box-shadow: 0 0 5px ", ";\n  ", "\n  ", "\n  ", "\n  /* ", " */\n\n  /* @keyframes moveIn { from{opacity: 0;} to{opacity: 0.6;} }\n  @keyframes moveOut { from{opacity: 0.6;} to{opacity: 0;} }\n\n  ", "\n\n  ", " */\n"])), function (_ref13) {
      var e = _ref13.color;
      return e;
    }, function (_ref14) {
      var e = _ref14.color;
      return e;
    }, function (_ref15) {
      var e = _ref15.top;
      return "top: ".concat(e, "px;");
    }, function (_ref16) {
      var e = _ref16.rounded;
      return e && "border-radius: 100px;";
    }, function (_ref17) {
      var e = _ref17.styles;
      return e;
    }, function (_ref18) {
      var e = _ref18.animation;
      return e;
    }, function (_ref19) {
      var e = _ref19.show;
      return e && n.css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    animation: moveIn 0.5s ease 0s 1 normal;\n  "])));
    }, function (_ref20) {
      var e = _ref20.show;
      return !e && n.css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    animation: moveOut 0.5s ease 0s 1 normal;\n  "])));
    });
  }
});